import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import React, { useEffect, useState } from 'react';
import { Button, TextField, InputAdornment } from '@material-ui/core';

import Prompt from '../Shared/Prompt/Prompt';
import PromptWrapper from '../Shared/Prompt/Wrapper';
import PromptActions from '../Shared/Prompt/Actions';

import { roles } from '../../Shared/utils';
import { decodeHTMLEntities } from '../../Functions/utils';
import { loginDemo, logout } from '../../Functions/auth';
import { getLocations } from '../../Functions/reporting';
import Swal from 'sweetalert2'

import { toastTimerValue } from '../../Shared/utils';

import './Auth.css';
import '../SweetAlert.css'


export default function LoginDemo() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [supported, setSupported] = useState(null);

  const [remember, setRemember] = useState(true);
  const [userLogin, setUserLogin] = useState({
    login: "DEMO_USER",
    password: "DEMO_PASSWORD"
  });


  const handleLogin = async (e) => {
    if (e)
      e.preventDefault();

    if (!userLogin.login || !userLogin.password) {
      return toast(decodeHTMLEntities(t('login.errors.incomplete')), { type: 'error' });
    }

    setLoading(true);
    const res = await loginDemo(userLogin, remember);

    console.log("41 - res=", res);
    if (!res || !res.success) {
      setLoading(false);
      return toast(decodeHTMLEntities(t('login.errors.' + res)), { type: 'error' });
    }

    if (res.user.roleId === roles.user) {
      const locRes = await getLocations(res.user.id, res.user.groupId);
      setLoading(false);

      if (!locRes || !locRes.success) {
        return toast(decodeHTMLEntities(t('login.errors.locations.' + locRes)), { type: 'error' });
      }

      if (locRes.locations.length === 0) {
        return logout().then(() => {
          localStorage.clear();

          setTimeout(() => {
            sessionStorage.clear();
          }, 500);

          toast(decodeHTMLEntities(t('login.errors.locations.no_location')), { type: 'error' })
        });
      }
    }

    setLoading(false);
    // Reset local storage when logging in with a different user
    if (Number(localStorage.getItem('id')) !== res.user.id) {
      const redirect = sessionStorage.getItem('redirect');

      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.setItem('redirect', redirect);
    }

    localStorage.setItem('id', res.user.id);
    localStorage.setItem('signedIn', res.success);

    // console.log("78 - res=", res);   
    // Refresh the whole website state using window.location
    window.location.pathname = sessionStorage.getItem('redirect') ?? '';
  };


  useEffect(() => {
    document.title = t('login.page');

    import('detect-browser').then(({ detect }) => (
      setSupported(!['edge', 'ie'].includes(detect().name))
    ));

    // TEST NOT SUPPORTED BROWSERS = 
    // setSupported(false);
  }, [t]);

  
  useEffect(() => {
    console.log("106 - supported=", supported);

    if (supported === true) {
      setTimeout(() => {
        handleLogin()
      }, 50);
    }
  }, [supported]);


  return (
    <Prompt>
      <form className="prompt__container" style={{ height: '60%' }} onSubmit={handleLogin}>
        {supported && <>
          <PromptWrapper>
            <div className="prompt__title">
              <h1>{t('login.title')}</h1>
            </div>

            <div className="prompt__content">
              <TextField
                InputProps={{
                  readOnly: true,
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">account_circle</span>
                  </InputAdornment>
                }}
                name="username"
                variant="outlined"
                label={t('login.field1')}
                value={userLogin.login}
                onChange={e => setUserLogin({ ...userLogin, login: e.target.value })}
              />
              <div className="checkbox action">
                <input
                  id="remember"
                  type="checkbox"
                  defaultChecked={remember}
                  onChange={() => setRemember(!remember)}
                />
                <label htmlFor="remember">{t('login.remember')} (16h)</label>
              </div>

              <TextField
                InputProps={{
                  readOnly: true,
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">lock</span>
                  </InputAdornment>
                }}
                name="password"
                type="password"
                variant="outlined"
                label={t('login.field2')}
                value={userLogin.password}
                onChange={e => setUserLogin({ ...userLogin, password: e.target.value })}
              />
              <Link to="/forgot" className="action">{t('login.forgot')}</Link>
            </div>
          </PromptWrapper>

          <PromptActions column>
            <Button className="btnPrimary" type="submit" disabled={loading}>
              {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('login.button')}
            </Button>
          </PromptActions>
        </>}

        {supported === false && (
          <div className="prompt__wrapper">
            <div className="prompt__title">
              <h1>{t('browser.unsupported.title')}</h1>
            </div>

            <div className="prompt__content">
              <p>{t('browser.unsupported.description')}</p>
              <p style={{ marginTop: '30px' }}>{t('browser.unsupported.download')}</p>
              <div className="browsers">
                <a href="https://microsoft.com/edge" aria-label={t('browser.new_edge')}>
                  <img src="/assets/images/edge.png" alt="edge" width="100px" height="100px" />
                </a>
                <a href="https://google.com/chrome" aria-label={t('browser.chrome')}>
                  <img src="/assets/images/chrome.png" alt="chrome" width="100px" height="100px" />
                </a>
                <a href="https://mozilla.org/firefox" aria-label={t('browser.firefox')}>
                  <img src="/assets/images/firefox.png" alt="firefox" width="100px" height="100px" />
                </a>
              </div>
            </div>
          </div>
        )}
      </form>
    </Prompt>
  );
}
